import { render } from "./WhatsAppIntegration.vue?vue&type=template&id=9302aa46"
import script from "./WhatsAppIntegration.vue?vue&type=script&lang=js"
export * from "./WhatsAppIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__